module.exports = __webpack_public_path__ + "img/qa.d6d7def3.svg";